<div class="row contact-without-login__row">
  <div class="col-12 offset-lg-2 col-lg-8 contact-without-login__intro">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('contact_unauthorized_intro')"
        [innerHTML]="translationService.getTranslation('contact_unauthorized_intro')"
        class="contact-without-login__intro-title"></h3>
  </div>
  <div class="col-12 offset-lg-2 col-lg-8 contact-without-login__description">
    <p [innerHTML]="translationService.getTranslation('contact_unauthorized_description')"
        class="contact-without-login__description-text"></p>
  </div>
</div>

<div class="row">
  <div class="col-12 offset-lg-2 col-lg-8">
    <mat-card class="mat-mdc-card-outlined mt-3 contact-without-login__card">
      <mat-card-content class="contact-without-login__card-content">
        <div class="row contact-without-login__form-row">
          <div class="contact-without-login__errors">
            <app-general-errors [errors]="errorsArr" class="contact-without-login__general-errors"></app-general-errors>
            @if (isLoading) {
              <div style="text-align: center;" class="contact-without-login__loading">
                <app-loading-spinner class="contact-without-login__spinner"></app-loading-spinner>
              </div>
            }
            @if (!clientFound && !isFirst) {
              <div class="text-danger mb-3 contact-without-login__client-not-found"
                   [innerHTML]="translationService.getTranslation('clientno_not_found')">
              </div>
            }

            @if (!clientFound) {
              <app-hup-subscription-address [showActivateCheckbox]="false"
                [controlGroup]="addressForm.get('contactAddress')"
                class="contact-without-login__address-form"></app-hup-subscription-address>
            }
            @if (!emailExists) {
              <div class="contact-without-login__email-section">
                @if (clientFound) {
                  <div class="text-danger mb-3 contact-without-login__no-email"
                       [innerHTML]="translationService.getTranslation('clientno_found_no_emailaddress_found')"></div>
                }
                <div class="contact-without-login__email-input-wrapper">
                  <mat-form-field class="col-12 contact-without-login__email-form-field">
                    <mat-label
                      class="contact-without-login__email-label">{{ translationService.getTranslation('label_email') }}
                    </mat-label>
                    <input maxLength="50" matInput [(ngModel)]="emailAddress" #email
                           class="contact-without-login__email-input">
                    @if (email === document?.activeElement && email.value.length >= 1) {
                      <mat-hint align="end" class="contact-without-login__email-hint">{{ email.value.length }}
                        / {{ email.maxLength }}
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
            @if (!isLoading) {
              <app-contact [unauthorized]="true" [userBackendId]="customer?.userBackendId"
                           [addressForm]="addressForm.get('contactAddress')"
                           [emailAddress]="emailAddress"
                           (saved)="savedRequest($event)"
                           class="contact-without-login__contact-form"></app-contact>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
